import { Text } from "@shared/designSystem/Texts";
import StatusDot from "@shared/designSystem/StatusDot";
import styles from "@shared/styles/components/StatusPill.module.css";

interface StatusPillProps {
    label: string;
    /** color of the status dot only — pass a designSystemStyles.colorStatus* token */
    dotColor: string;
    className?: string;
    title?: string;
}

export const StatusPill: React.FC<StatusPillProps> = ({ label, dotColor, className, title }) => (
    <span className={[styles.pill, "DSStatusPill", className].filter(Boolean).join(" ")} title={title}>
        <StatusDot color={dotColor} />
        <Text text={label} truncate className={styles.label} />
    </span>
);
